<script setup>
import DpIcon from './DpIcon';
import { useI18n } from 'vue-i18n'
import { isEmpty } from 'lodash';
import DpExpand from "./DpExpand";
import DpReadValues from "./DpReadValues";
import DpTable from './DpTable';
import DpButton from './DpButton';
import { ref, nextTick, watch, useSlots } from 'vue';

const { t } = useI18n()
const slots = useSlots();
const props = defineProps({
  modelValue: { type: [Object, Array] },
  keyMap: { type: Object },
  title: { type: String },
  isEditSlotActive: { type: Boolean, default: false },
  isReadOnly: { type: Boolean, default: false },
  buttonLabel: { type: String, default: undefined },
  buttonIcon: { type: [Boolean, String], default: true }
});
const emit = defineEmits(['activate-edit-slot', 'deactivate-edit-slot']);

const hasEditMode = ref((props.isReadOnly) ? false : !props.isEditSlotActive);
const isBodyMounted = ref(false);

async function activateSlot() {
  isBodyMounted.value = true;
  await nextTick(() => {
    hasEditMode.value = true;
    emit('activate-edit-slot');
  });
}

function deactivateSlot() {
  hasEditMode.value = false;
  setTimeout(() => {
    isBodyMounted.value = false;
    emit('deactivate-edit-slot');
  }, 300);
}

watch(props.isEditSlotActive, (value) => {
  if (props.isReadOnly)
    return;
  if (value === true) {
    activateSlot();
  } else {
    deactivateSlot();
  }
})

</script>

<script>
export default {
  name: "DpReadEditDelete"
}
</script>

<template>
  <div class="dp-read-edit-delete">
    <div class="dp-read-edit-delete__title">
      <h4><slot name="title">{{ props.title }}</slot></h4>
    </div>
    <div class="dp-read-edit-delete__body">

      <div v-if="isBodyMounted">
        <DpExpand>
          <div v-show="hasEditMode && !props.isReadOnly">
            <slot></slot>
          </div>
        </DpExpand>
      </div>
      <DpExpand>
        <div v-show="!hasEditMode">
          <slot v-if="props.modelValue !== undefined" name="read" v-bind:data="props.modelValue">
            <DpTable v-if="Array.isArray(props.modelValue)" size="large" :data="props.modelValue" :columns="props.keyMap"></DpTable>
            <DpReadValues v-else :data="props.modelValue" :keyMap="props.keyMap"></DpReadValues>
          </slot>
          <slot v-else name="read"></slot>
        </div>
      </DpExpand>

    </div>
    <template v-if="!props.isReadOnly">
      <DpExpand>
        <div v-show="!hasEditMode" class="dp-read-edit-delete__controls">
          <DpButton tabindex="0" @click="activateSlot" @keypress="activateSlot">
            <span><DpIcon v-if="props.buttonIcon" :icon="(props.buttonIcon === true) ? 'edit' : props.buttonIcon"/>{{
                !isEmpty(props.buttonLabel) ? props.buttonLabel : t('edit.buttonLabel')
              }}</span>
          </DpButton>
        </div>
        <div v-show="hasEditMode && slots['delete'] !== undefined" class="dp-read-edit-delete__controls">
          <slot name="delete"></slot>
        </div>
      </DpExpand>
    </template>
  </div>
</template>

<style lang="scss">
.dp-read-edit-delete {
  $padding: .75rem 1.5rem;
  $border: 2px solid var(--use-theme__ui-gradient-1);

  border-radius: 8px;
  margin: 1rem 0;
  border: $border;

  &__title {
    border-bottom: $border;
    padding: $padding;
  }

  &__body {
    padding: $padding;
  }

  &__controls {
    border-top: $border;
    padding: $padding;
  }
}
</style>

<i18n>
{
}
</i18n>
